export const keyPressEventWrapper = (event: any, callback: any, keyToPress: string) => {
    if(event.key == keyToPress)
        callback()
}